import styled from 'styled-components';

/**
 * Kiosk Pro breakpoints - optimized for kiosk hardware
 */
const KIOSK_PRO_LANDSCAPE_BREAKPOINT = 1510;
const KIOSK_PRO_PORTRAIT_BREAKPOINT = 720;

export const KIOSK_PRO_MEDIA = {
  maxWidth: `only screen and (max-width: ${KIOSK_PRO_LANDSCAPE_BREAKPOINT}px)`,
  landscapeMaxWidth: `only screen and (orientation: landscape) and (max-width: ${KIOSK_PRO_LANDSCAPE_BREAKPOINT}px)`,
  portraitMaxWidth: `only screen and (orientation: portrait) and (max-width: ${KIOSK_PRO_PORTRAIT_BREAKPOINT}px)`,
};

export const PageContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  min-height: 80dvh;
  max-width: 1400px;
  margin: 0 auto;
  place-items: center;
  text-align: center;
  gap: 0;

  @media (orientation: landscape) {
    grid-template-columns: minmax(340px, auto) 1fr;
    min-height: 100dvh;
    gap: 2rem;
  }
`;

export const ContentContainer = styled.div`
  max-width: 1000px;
  padding: 40px;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Title = styled.h1`
  font-size: clamp(30px, 11.46vw, 36px);
  font-weight: 700;
  line-height: 1;

  @media ${KIOSK_PRO_MEDIA.maxWidth} {
    font-size: clamp(26px, 11.46vw, 28px);
  }
`;

export const Subtitle = styled.p`
  font-size: clamp(24px, 3vw, 36px);
  font-weight: 700;
  line-height: 1;

  @media ${KIOSK_PRO_MEDIA.maxWidth} {
    font-size: clamp(26px, 11.46vw, 28px);
  }
`;
